<template>
    <div class="container">
        <a :href="url" target="_blank" rel="nofollow">
            <div class="crop">
                <img :src="img" alt="" srcset="">
            </div>
            <h4 class="title"> {{ title }} </h4>
            <div class="description">
                {{ description.split(' ').slice(0, 29).join(' ') + ' [...]' }}
            </div>
        </a>
    </div>
</template>

<script>
export default {
    name: "Article",
    props: {
        url: String,
        img: String,
        title: String,
        description: String,
    },
}
</script>

<style lang="scss" scoped>

div.container {
    display: flex;
    width: 100%;
    padding: 1.2rem;
    a {
        display: flex;
        flex-direction: column;
        width: 100%;
        img {
            width: 100%;
            height: auto;
        }
    }
    padding-bottom: 3rem;
}

@media screen and (min-width: 600px) {
    div.container {
        width: 400px;
        //padding: 0.6rem;
        margin: 0.5rem;
        padding: 0.3rem;
        &:hover {
            border: 1px solid white;
            //padding: 0.6rem;
        }
        a {
            display: flex;
            max-width: 400px;
            flex-direction: column;
            align-items: center;
            text-decoration: none;
            div.description {
                text-align: left;
            }
            div.crop {
                max-width: 400px;
                height: 160px;
                overflow: hidden;
                img {
                    max-width: 400px;
                    height: auto;
                    max-width: initial;
                }
            }
        }
    }
}

</style>